import { useState } from 'react';
import './addWorkingTemplate.scss';
import PlainNavBar from './navbar/navBar';
import InputBox, { DropDown } from 'components/inputBox/inputBox';
import DropDownWithInput from '../../components/dropdownWithInput/dropdownWithInput';
import HolidaySelection from './holidaySelection/holidaySelection';
import { GreenCheckBox } from '../../components/greenCheckboxes/greenCheckBox';

interface AddWorkingTemplateProps {
  type?: string;
}

const AddWorkingTemplate = ({ type = 'create' }: AddWorkingTemplateProps) => {
  const [holiday, setHoliday] = useState<string>('적용안함');
  return (
    <div className="addWorkingTemplate">
      <PlainNavBar />
      <div className="titleBar">
        <div className="header">근로템플릿 추가</div>
        <div className="subHeader">템플릿 정보를 입력해주세요.</div>
      </div>
      <div className="container">
        <div className="leftContainer">
          <div className="header">템플릿 정보</div>
          <InputBox value={type === 'edit' ? '템플릿명 입력' : ''} label="템플릿명*" />

          <DropDownWithInput
            label="급여정보*"
            options={['시급', '일급', '월급']}
            placeHolder={type === 'edit' ? '9160' : ''}
          />

          <div className="areaHead">쥬휴수당 선택</div>

          <HolidaySelection
            primaryLabel={'(+) 주휴수당 자동 가산'}
            secondaryLabel={'(자동)근로기준법 기준'}
            ternaryLabel={'(수동)월 근무시간'}
            ternaryUnits={'시간'}
            selection={type === 'edit' ? true : false}
            title={' '}
          />
          <HolidaySelection
            primaryLabel={'(-) 휴게시간 자동 차감'}
            secondaryLabel={'(자동)근로기준법 기준'}
            ternaryLabel={'(수동)월 휴계시간'}
            ternaryUnits={'분'}
            selection={type === 'edit' ? true : false}
            title={' '}
          />
          <HolidaySelection
            title={'  '}
            primaryLabel={'(+) 추가, 야간, 휴일수당 50% 자동 가산'}
            selection={type === 'edit' ? true : false}
          />

          <div className="incomeDeclaration">
            <DropDown
              label="소득신고"
              value={type === 'edit' ? '4대보험' : ''}
              options={['적용안함', '4대보험']}
              onSelect={(data: string) => {
                setHoliday(data);
              }}
            />

            <div className="checkboxRow" style={{ opacity: holiday === '4대보험' ? 100 : 0 }}>
              <div className="checkBoxWrapper">
                <GreenCheckBox onCheck={() => {}} defaultValue={false} text={'국민연금'} />
              </div>
              <div className="checkBoxWrapper">
                <GreenCheckBox onCheck={() => {}} defaultValue={false} text={'건강보험'} />
              </div>
              <div className="checkBoxWrapper">
                <GreenCheckBox onCheck={() => {}} defaultValue={false} text={'고용보험'} />
              </div>
              <div className="checkBoxWrapper">
                <GreenCheckBox onCheck={() => {}} defaultValue={false} text={'산재보험'} />
              </div>
            </div>
          </div>
        </div>
        <div className="rightContainer">
          <div className="title">근로 템플릿이란?</div>
          <div className="description">
            직원 급여 정보를 템플릿으로 저장해두면 여러 명의 <br />
            직원에게 급여 정보를 한꺼번에 적용할 수 있어요
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddWorkingTemplate;
